import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import EntryCamera from './Entry CameraLiveFeed/EntryCamera'
import DetectionStatistics from './DetectionStatistics/DetectionStatistics'
import RecentEntryDetections from './RecentEntryDetections/RecentEntryDetections'
import { Entrycameramonitor } from "../../../../api/EntryCameraMonitorifl";
import FiltersComponent from "../../pages/components/Filters/FiltersComponent";

import { errorToast } from '../../../../_helper/helper'
import { getCurrentcompleteDate } from '../../../../utils/getCurrentcompleteDate'
import SopFollowed from './SOPFollowed/SopFollowed'
import ImageZoomSingleImage from '../../../Dashboards/AreaDashbaord/reports/Components/LiveAlertsCards/ImageZoomSingleImage'



const LOCAL_STORAGE_KEY = 'defaultPageFilters';

function Entry_Camera_Monitor() {

   //zoom image start
    const [showModal, setShowModal] = useState(false);
    const [imageUrl, setImageurl] = useState();
    const handleImageClick = (photo) => {
      console.log('photttt', photo)
        setImageurl(photo);
        setShowModal(!showModal);
      };
      //zoom image End


  // const [pageLoader, setpageLoader] = useState(false)
  const getInitialFilters = () => {
    const savedFilters = localStorage.getItem(LOCAL_STORAGE_KEY);
    return savedFilters
      ? JSON.parse(savedFilters)
      : {
        selectDate: 'date',
        time: '',
        week: '',
        date: getCurrentcompleteDate(),
        month: '',
        shift: '',
        starting: '',
        ending: ''
      };
  };
  const [filters, setFilters] = useState(getInitialFilters)
  const handleSave = () => {
    const updatedFilters = {
      selectDate: filters.selectDate,
      time: '',
      week: '',
      date: '',
      month: '',
      shift: filters.shift,
      starting: '',
      ending: '',
    };

    switch (filters.selectDate) {
      case 'date':
        if (!filters.date) {
          errorToast('Please select a Date!');
          return;
        }
        updatedFilters.date = filters.date;
        break;
      case 'week':
        if (!filters.week) {
          errorToast('Please select a Week!');
          return;
        }
        updatedFilters.week = filters.week;
        break;
      case 'month':
        if (!filters.month) {
          errorToast('Please select a Month!');
          return;
        }
        updatedFilters.month = filters.month;
        break;
      case 'custom':
        if (!filters.starting || !filters.ending) {
          errorToast('Please select both Startin and Ending Dates!');
          return;
        }
        updatedFilters.starting = filters.starting;
        updatedFilters.ending = filters.ending;
        break;
      default:
        break;
    }
    getlivealertsdata()
    getCamstatsData()
    getlivecounts()
    getlive_sop()

    setFilters(updatedFilters);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
    // setCallAPi((prev) => !prev);
  }
  const handleCancel = () => {
    const updatedFilters = {
      selectDate: 'date',
      time: '',
      week: '',
      date: getCurrentcompleteDate(),
      month: '',
      shift: '',
      starting: '',
      ending: ''
    };
    getlivealertsdata()
    getCamstatsData()
    getlivecounts()
    getlive_sop()

    setFilters(updatedFilters)
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updatedFilters));
    // setCallAPi(!callApi)
  }

  const [Livealertsdata, setLivealertsdata] = useState([])
  const [Camstatusdata, setCamstatusdata] = useState([])
    const [statsLoader, setStatsLoader] = useState(false)
      const [alertcounts, setalertcounts] = useState([])
        const [alertsop, setalertsop] = useState([])
      
    
  


  const getlivealertsdata = async () => {
    const userData = JSON.parse(localStorage.getItem('userData'));

    const payload = {
      client_id: userData?.client?.id,
      factory_id: userData?.factory?.id,
      limit: "100",
      offset: 0,

      camera_id: "",
      employee_id: "",
      filters: {
        date: filters?.date,
        week: filters?.week,
        month: filters?.month,
        starting: "",
        ending: "",
      },
    };

    const res = await Entrycameramonitor.getLiveAlertss(payload);

    if (res.status === 200) {
        const filtered = res.data.data.logs.filter((e)=>e.camera_position_no=='Gate In')
      setLivealertsdata(filtered)
      console.log(filtered)
      console.log("..................................")

    }

  };

  //  ..................camerastatus..........
  const getCamstatsData = async () => {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const payload = {
      client_id: userData?.client?.id,
      factory_id: userData?.factory?.id,
      limit: "100",
      camera_id: "",
      employee_id: "",
      filters: {
        date: filters?.date,
        week: filters?.week,
        month: filters?.month,
        starting: "",
        ending: ""
      }


    }

    const res = await Entrycameramonitor.getCameraStatus(payload)

    if (res.status === 200) {

      setCamstatusdata(res.data.data.gate_in)
      console.log(res)
      console.log("...............setCamstatusdata...................")

    }

  }

  const getlivecounts = async () => {
      setStatsLoader(true);
      const userData = JSON.parse(localStorage.getItem('userData'));
      
      const payload = {
        client_id: userData?.client?.id,
        factory_id: userData?.factory?.id,
        filters: {
          date: filters?.date,
          week: filters?.week,
          month: filters?.month,
          starting: "",
          ending: ""
        }
      };
  
      try {
        const res = await Entrycameramonitor.getLivecounts(payload);
  
        if (res.status === 200) {
          setalertcounts(res.data.data);
          console.log(res);
          console.log("................getLivecounts..................");
        }
      } catch (error) {
        console.error("Error fetching stats:", error);
      } finally {
        setStatsLoader(false);
      }
    };


     const getlive_sop = async () => {
            setStatsLoader(true);
            const userData = JSON.parse(localStorage.getItem('userData'));
            
            const payload = {
              client_id: userData?.client?.id,
              factory_id: userData?.factory?.id,
              camera_id: "",
              employee_id: "",
              filters: {
                date: filters?.date,
                week: filters?.week,
                month: filters?.month,
                starting: "",
                ending: ""
              }
            };
        
            try {
              const res = await Entrycameramonitor.getLivesop_stats(payload);
        
              if (res.status === 200) {
                setalertsop(res.data.data);
                console.log(res);
                console.log("................getlive_sop..................");
              }
            } catch (error) {
              console.error("Error fetching stats:", error);
            } finally {
              setStatsLoader(false);
            }
          };

  

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setStatsLoader(true);
        await Promise.all([
          getlivealertsdata(),
         
          getCamstatsData(),
          getlivecounts(),
          getlive_sop()

          
        ]);
      } catch (error) {
        console.error("Error loading dashboard data:", error);
      } finally {
        setStatsLoader(false);
      }
    };
  
    fetchAllData();
  }, []);

   function getFilterLabel(filters) {
    switch (filters.selectDate) {
      case 'date':
        return filters.date ? `Date: ${filters.date}` : '';
      case 'week':
        return filters.week ? `Week: ${filters.week}` : '';
      case 'month':
        return filters.month ? `Month: ${filters.month}` : '';
      case 'custom':
        if (filters.starting && filters.ending) {
          return `Custom: ${filters.starting} to ${filters.ending}`;
        }
        return '';
      default:
        return '';
    }
  }
  


  return (

    <Container fluid={true} className=''>
      <hr />

      {/* heading..................... */}
      <Row className="">
        <Col>
          <h1 style={{ fontSize: "24px", color: "#1D67AA", fontWeight: "600" }}>
            Entry Camera Monitor
          </h1>
          <p style={{ color: "#535353", fontSize: "14px" }}>
            {getFilterLabel(filters)}
          </p>
        </Col>
        <Col xs="12" xl="9" className="d-flex flex-wrap justify-content-end align-items-end mb-2">
          <FiltersComponent setFilters={setFilters}
            filtersConfig={[
              // { key: "cameraType", options: ["OCR", "HSE"], placeholder: "Vehicle Type" },
              // { key: "shift", options: ["Shift A", "Shift B"], placeholder: "Shift" },
              { key: "selectDate", options: ["date", "week", 'month'], placeholder: "date" },
            ]}
            handleSave={handleSave}
            handleCancel={handleCancel}
            filters={filters}
          />
        </Col>

      </Row>

      
        <>
            
            
        {/* ................Entry Camera Live Feed............. */}
  
        <Row>
          <Col md={8}>
            <EntryCamera data={Camstatusdata[0]}  statsLoader={statsLoader} handleImageClick={handleImageClick} />
  
  
  
          </Col>
          <Col>

            <DetectionStatistics  alertcount={alertcounts} Camstatusdata={Camstatusdata[0]} statsLoader={statsLoader}/>
  
  
          </Col>
        </Row>
        <Row>
          {/* ................SopFollowed............. */}
          <Col>
          
          <SopFollowed  alertsop={alertsop}/>

          </Col>

        </Row>
  
        {/* ................Recent Entry Detections............. */}
  
        <RecentEntryDetections handleImageClick={handleImageClick}  filters={filters}/>
              </>
      


{showModal && (
          <ImageZoomSingleImage
            photo={imageUrl}
            setShowModal={setShowModal}
          />
        )}
    </Container>
  )
}
export default Entry_Camera_Monitor